export default __webpack_public_path__ + "2203f2ee13af7a7d0c35e9c8b3a37d20.svg";